import { usePageMeta } from "@/hooks/usePageMeta";
import { Reveal } from "@/components/Reveal";

const Block = ({ title, children }) => (
  <Reveal>
    <div className="border-t border-hairline py-8 md:py-10">
      <h2 className="font-serif text-2xl md:text-3xl tracking-tight">{title}</h2>
      <div className="mt-4 text-soot text-[15px] md:text-base leading-relaxed space-y-3">{children}</div>
    </div>
  </Reveal>
);

export default function MentionsLegales() {
  usePageMeta(
    "Mentions légales — Les Mots pour le Dire",
    "Mentions légales du site Les Mots pour le Dire — écrivain public : éditrice, hébergement, création, propriété intellectuelle."
  );

  return (
    <div className="pt-36 md:pt-44 pb-24" data-testid="legal-page">
      <div className="mx-auto max-w-3xl px-6">
        <Reveal>
          <p className="eyebrow">Informations légales</p>
        </Reveal>
        <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl tracking-tight leading-[1.05] mt-5">
          Mentions légales
        </h1>

        <div className="mt-12" data-testid="legal-mentions-section">
          <Block title="Éditrice du site">
            <p>
              Le site lesmots-pourledire.fr est édité par Carole Bourbasquet, exerçant sous le nom
              « Les Mots pour le Dire », écrivain public.
            </p>
            <p>
              Contact : 06 03 27 46 10 —{" "}
              <a href="mailto:contact@lesmots-pourledire.fr" className="link-underline !text-[15px]" data-testid="legal-email-link">
                contact@lesmots-pourledire.fr
              </a>
            </p>
          </Block>

          <Block title="Hébergement">
            <p>Ce site est hébergé sur la plateforme Emergent.</p>
          </Block>

          <Block title="Création du site">
            <p>
              Site conçu et réalisé par l'agence{" "}
              <a
                href="https://www.thehillproject.fr"
                target="_blank"
                rel="noopener noreferrer"
                className="link-underline !text-[15px]"
                data-testid="legal-hill-link"
              >
                THE HILL PROJECT
              </a>
              .
            </p>
          </Block>

          <Block title="Propriété intellectuelle">
            <p>
              L'ensemble des contenus de ce site (textes, logo, éléments graphiques) est la propriété
              exclusive de Les Mots pour le Dire. Toute reproduction, même partielle, est interdite
              sans autorisation écrite préalable.
            </p>
          </Block>
        </div>
      </div>
    </div>
  );
}
